// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Next__Image = require("../../reason/next/Next__Image.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let TMPUIKIT____ImgGallery = require("../../temporaryUIKit/TMPUIKIT____ImgGallery/TMPUIKIT____ImgGallery.bs.js");
let ConversationMessageImages_SingleImage_image_graphql = require("../../__generated__/ConversationMessageImages_SingleImage_image_graphql.bs.js");
let ConversationMessageImages_conversationMessage_graphql = require("../../__generated__/ConversationMessageImages_conversationMessage_graphql.bs.js");
let ConversationMessageImages_OneOfSeveralImages_image_graphql = require("../../__generated__/ConversationMessageImages_OneOfSeveralImages_image_graphql.bs.js");

function use(imageUrl) {
  let match = React.useState(() => false);
  let setDoPreload = match[1];
  let timer = React.useRef(undefined);
  return {
    preloadElement: match[0] && imageUrl !== undefined ? JsxRuntime.jsx("link", {
        as: "image",
        href: imageUrl,
        rel: "preload"
      }) : null,
    onMouseEnter: param => {
      Stdlib_Option.forEach(timer.current, prim => {
        clearTimeout(prim);
      });
      timer.current = Primitive_option.some(setTimeout(() => setDoPreload(param => true), 100));
    },
    onMouseLeave: param => Stdlib_Option.forEach(timer.current, prim => {
      clearTimeout(prim);
    })
  };
}

let PreloadImageOnHover = {
  use: use
};

let convertFragment = ConversationMessageImages_OneOfSeveralImages_image_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationMessageImages_OneOfSeveralImages_image_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationMessageImages_OneOfSeveralImages_image_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationMessageImages_OneOfSeveralImages_image_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationMessageImages_OneOfSeveralImages_image_graphql.node, convertFragment, fRef);
}

let ImageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function Conversation__MessageImages$OneOfSeveralImages(props) {
  let onClick = props.onClick;
  let __size = props.size;
  let size = __size !== undefined ? __size : "small";
  let image = RescriptRelay_Fragment.useFragment(ConversationMessageImages_OneOfSeveralImages_image_graphql.node, convertFragment, props.image);
  let match = use(props.preloadImageUrl);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("button", {
        children: JsxRuntime.jsx(Next__Image.make, {
          src: image.oneOfSeveralUrl,
          width: 200,
          height: 200,
          unoptimized: true,
          alt: "",
          className: "w-full h-auto rounded object-cover transition-opacity duration-150 hover:opacity-80"
        }),
        className: size === "small" ? "col-span-2 row-span-2" : "col-span-3 row-span-3",
        onClick: param => onClick(),
        onMouseEnter: match.onMouseEnter,
        onMouseLeave: match.onMouseLeave
      }),
      match.preloadElement
    ]
  });
}

let OneOfSeveralImages = {
  ImageFragment: ImageFragment,
  make: Conversation__MessageImages$OneOfSeveralImages
};

let convertFragment$1 = ConversationMessageImages_SingleImage_image_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationMessageImages_SingleImage_image_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationMessageImages_SingleImage_image_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationMessageImages_SingleImage_image_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationMessageImages_SingleImage_image_graphql.node, convertFragment$1, fRef);
}

let ImageFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function Conversation__MessageImages$SingleImage(props) {
  let onClick = props.onClick;
  let image = RescriptRelay_Fragment.useFragment(ConversationMessageImages_SingleImage_image_graphql.node, convertFragment$1, props.image);
  let match = use(props.preloadImageUrl);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("button", {
        children: JsxRuntime.jsx("img", {
          className: "w-full h-auto rounded object-cover transition-opacity duration-150 hover:opacity-80 ",
          src: image.url
        }),
        className: "col-span-6",
        onClick: param => onClick(),
        onMouseEnter: match.onMouseEnter,
        onMouseLeave: match.onMouseLeave
      }),
      match.preloadElement
    ]
  });
}

let SingleImage = {
  ImageFragment: ImageFragment$1,
  make: Conversation__MessageImages$SingleImage
};

let convertFragment$2 = ConversationMessageImages_conversationMessage_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationMessageImages_conversationMessage_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationMessageImages_conversationMessage_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationMessageImages_conversationMessage_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(ConversationMessageImages_conversationMessage_graphql.node, convertFragment$2, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function Conversation__MessageImages$ImageGrid(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "max-w-md w-[60vw] grid grid-cols-6 gap-1"
  });
}

let ImageGrid = {
  make: Conversation__MessageImages$ImageGrid
};

function Conversation__MessageImages(props) {
  let match = RescriptRelay_Fragment.useFragment(ConversationMessageImages_conversationMessage_graphql.node, convertFragment$2, props.message);
  let images = Stdlib_Option.getOr(Stdlib_Option.map(match.images, param => Stdlib_Array.filterMap(param.edges, edge => Stdlib_Option.map(edge, edge => edge.node))), []);
  let match$1 = React.useState(() => false);
  let setIsFullscreenCarouselOpen = match$1[1];
  let imagesForCarousel = images.map(image => ({
    fullscreen: image.carouselFullscreen,
    large: image.carouselLarge,
    small: image.carouselSmall,
    thumb: image.carouselThumb
  }));
  let match$2 = React.useState(() => {});
  let setSelectedImage = match$2[1];
  let onSelectImage = i => {
    setSelectedImage(param => i);
    setIsFullscreenCarouselOpen(param => true);
  };
  let len = images.length;
  let tmp;
  if (len !== 1) {
    if (len !== 0) {
      let numImages = images.length;
      if (numImages % 3 === 2) {
        let firstTwo = images.slice(0, 2);
        let rest = images.slice(2);
        tmp = JsxRuntime.jsxs(Conversation__MessageImages$ImageGrid, {
          children: [
            firstTwo.map((image, i) => JsxRuntime.jsx(Conversation__MessageImages$OneOfSeveralImages, {
              image: image.fragmentRefs,
              size: "large",
              onClick: () => onSelectImage(i),
              preloadImageUrl: image.carouselFullscreen
            }, i.toString())),
            rest.map((image, i) => JsxRuntime.jsx(Conversation__MessageImages$OneOfSeveralImages, {
              image: image.fragmentRefs,
              onClick: () => onSelectImage(i),
              preloadImageUrl: image.carouselFullscreen
            }, (i + 2 | 0).toString()))
          ]
        });
      } else {
        tmp = JsxRuntime.jsx(Conversation__MessageImages$ImageGrid, {
          children: images.map((image, i) => JsxRuntime.jsx(Conversation__MessageImages$OneOfSeveralImages, {
            image: image.fragmentRefs,
            onClick: () => onSelectImage(i),
            preloadImageUrl: image.carouselFullscreen
          }, i.toString()))
        });
      }
    } else {
      tmp = null;
    }
  } else {
    let image = images[0];
    tmp = JsxRuntime.jsx(Conversation__MessageImages$ImageGrid, {
      children: JsxRuntime.jsx(Conversation__MessageImages$SingleImage, {
        image: image.fragmentRefs,
        onClick: () => onSelectImage(0),
        preloadImageUrl: image.carouselFullscreen
      })
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(TMPUIKIT____ImgGallery.CarouselDialog.make, {
        isOpen: match$1[0],
        onDismiss: () => setIsFullscreenCarouselOpen(param => false),
        children: JsxRuntime.jsx(TMPUIKIT____ImgGallery.Carousel.make, {
          images: imagesForCarousel,
          onSelect: i => setSelectedImage(param => i),
          selectedIndex: Stdlib_Option.getOr(match$2[0], 0),
          imgSize: "fullscreen"
        })
      }),
      tmp
    ]
  });
}

let Gallery;

let CarouselImg;

let make = Conversation__MessageImages;

exports.PreloadImageOnHover = PreloadImageOnHover;
exports.OneOfSeveralImages = OneOfSeveralImages;
exports.SingleImage = SingleImage;
exports.Fragment = Fragment;
exports.Gallery = Gallery;
exports.CarouselImg = CarouselImg;
exports.ImageGrid = ImageGrid;
exports.make = make;
/* react Not a pure module */
